import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngxs/store";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { FilterBySearchTextAction } from "../shared/store/learning-objectives.state";

import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-search",
  standalone: true,
  imports: [FormsModule],
  styleUrls: ["search.component.scss"],
  template: `
    <div class="search-container">
      <input
        class="form-control border flex-grow-1"
        [ngModelOptions]="{ standalone: true }"
        [placeholder]="'Zoek in leerdoelen'"
        [ngModel]="searchText"
        (ngModelChange)="changed($event)"
        (focus)="focus($event)"
      />
    </div>
  `,
})
export class SearchComponent {
  searchText: string;
  modelChangeSubscription: Subscription;
  modelChanged$: Subject<string> = new Subject<string>();

  @Input() disabled = false;
  @Input() placeholdertext: string;
  @Output() filterText = new EventEmitter<string>();

  constructor(private store: Store) {
    this.modelChangeSubscription = this.modelChanged$
      .pipe(
        debounceTime(300), // wait 300ms after the last event before emitting last event
        distinctUntilChanged() // only emit if value is different from previous value
      )
      .subscribe((txt) =>
        this.store.dispatch(new FilterBySearchTextAction(txt))
      );
  }

  ngOnDestroy(): void {
    if (this.modelChangeSubscription) {
      this.modelChangeSubscription.unsubscribe();
    }
  }

  changed = (text: string) => this.modelChanged$.next(text);
  focus = ($event: MouseEvent) => {
    $event.preventDefault();
    $event.stopPropagation();
  };
}
